import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import Dropdown from '../utility/Dropdown';
import { range, findMinMaxPaxRate } from '../../js/utility';
import { confirmSignUp } from '../../actions/auth';

class PaxSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      adult:
        ((props.isByAge || props.isByPax) && props.value.adult) ||
        props.min ||
        1,
      child: ((props.isByAge || props.isByPax) && props.value.child) || 0,
      neutral: props.value || props.max,
      initialMax: props.min
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.handleSelectAdult = this.handleSelectAdult.bind(this);
    this.handleSelectChild = this.handleSelectChild.bind(this);
  }

  get neutral() {
    return {
      neutral: this.state.neutral
    };
  }

  get ageist() {
    return {
      adult: this.state.adult,
      child: this.state.child
    };
  }

  componentDidMount() {
    this.props.onChange(
      this.props.isByAge !== true ? this.neutral : this.ageist
    );
  }

  handleSelect(val) {
    this.setState({ neutral: parseInt(val) }, () => {
      this.props.onChange(this.neutral);
    });
  }

  handleSelectAdult(val) {
    this.setState({ adult: parseInt(val) }, () => {
      this.props.onChange(this.ageist);
    });
  }

  handleSelectChild(val) {
    this.setState({ child: parseInt(val) }, () => {
      this.props.onChange(this.ageist);
    });
  }

  render() {
    const {
      isByAge,
      isByPax,
      min,
      max,
      children,
      t,
      showError,
      perPaxOnly,
      separatedPrice
    } = this.props;

    if (!isByAge && !isByPax) {
      return (
        <>
          <div className='fe-menu-subheading'>{t('gen:selectNumPax')}</div>
          <Dropdown
            value={this.state.neutral}
            onChange={this.handleSelect}
            options={range(min, max)}
          />
          {children}
        </>
      );
    }

    let { adult, child } = this.state;

    // reset adult if initialMax & props.max not equal (after move to other Trip)
    if (this.state.initialMax !== this.props.min){
      this.setState({
        adult: this.props.min,
        initialMax: this.props.min
      });
      this.handleSelectAdult( this.props.min);
    }
    const optionsAdult= range(1, max); // Minimum 1 adult
    const optionsChild = optionsAdult.map(n => n - 1);

    // set adult/child pax selection
    if (this.props.trip_price){
      optionsAdult.splice(0,optionsAdult.length);
      const adult_rate_keys = Object.keys(this.props.trip_price.adult_rate);
      adult_rate_keys.forEach(key => {
        switch (key){
          case 'one_pax':
            optionsAdult.push(1);
            break;
          case 'two_pax':
            optionsAdult.push(2);
            break;
          case 'three_pax':
            optionsAdult.push(3);
            break;
          case 'four_pax':
            optionsAdult.push(4);
            break;
        }
      });
      optionsAdult.sort(function(a, b){return a-b;});
      const maxAdult = Math.max(...optionsAdult);
      if (adult > maxAdult){
        adult = maxAdult;
      }
      if ((adult+child) > max){
        if (adult > max){
          adult = max;
          child = 0;
          this.handleSelectAdult(adult);
          this.handleSelectChild(child);
        }
        else{
          child = max - adult;
          if (child < findMinMaxPaxRate(this.props.trip_price.child_rate, 'min')){
            child = 0;
          }
          this.handleSelectChild(child);
        }
      }
      optionsChild.splice(0,optionsChild.length);
      optionsChild.push(0);
      if (this.props.trip_price.child_rate){
        const child_rate_keys = Object.keys(this.props.trip_price.child_rate);
        child_rate_keys.forEach(key => {
          switch (key){
            case 'one_pax':
              optionsChild.push(1);
              break;
            case 'two_pax':
              optionsChild.push(2);
              break;
            case 'three_pax':
              optionsChild.push(3);
              break;
            case 'four_pax':
              optionsChild.push(4);
              break;
          }
          optionsChild.sort(function(a, b){return a-b;});
        });
      }
    }

    const total = adult + child;
    const disabledAdult = optionsAdult.map(n => {
      // if (n < min) return true;
      if (n < 1) return true;
      return total < max ? n + child > max : n > adult;
    });
    const disabledChild = optionsChild.map(n => {
      // if (n < min && n != 0) return true;
      if (n < 1 && n != 0) return true;
      return total < max ? n + adult > max : n > child;
    });
    const className = 'fe-book-now-btn';

    return (
      <>
        <div className='fe-menu-subheading'>
          {t('gen:selectNumPaxAdult')}
        </div>
        <div className='fe-dropdown-box'>
          <Dropdown
            value={adult}
            onChange={this.handleSelectAdult}
            options={optionsAdult}
            disabledOptions={disabledAdult}
            className={className}
          />
          {((separatedPrice || []).length > 0) ? (
            <span
              className='fe-menu-text'
              dangerouslySetInnerHTML={{
                __html: separatedPrice[0]
              }}
            />
          ) : null}
        </div>
        {!perPaxOnly && (
          <>
            <div className='fe-menu-subheading'>
              {t('gen:selectNumPaxChild')}
            </div>
            <div className='fe-dropdown-box'>
              <Dropdown
                value={child}
                onChange={this.handleSelectChild}
                options={optionsChild}
                disabledOptions={disabledChild}
                className={className}
              />
              {((separatedPrice || []).length > 1) ? (
                <span
                  className='fe-menu-text'
                  dangerouslySetInnerHTML={{
                    __html: separatedPrice[1]
                  }}
                />
              ) : null}
            </div>
          </>
        )}

        {showError && total < min ? (
          <span className='fe-form-error'>{t('error:minPax', { min })}</span>
        ) : null}
        {children}
      </>
    );
  }
}

PaxSelector.propTypes = {
  isByAge: PropTypes.bool.isRequired,
  isByPax: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  trip_price: PropTypes.object,
  children: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  showError: PropTypes.bool.isRequired,
  separatedPrice: PropTypes.array
};

PaxSelector.defaultProps = {
  showError: false
};

export default withTranslation()(PaxSelector);
